<div class="valign-wrapper">
  <mat-icon *ngIf="!!icon" class="left" [style.color]="iconColor ?? '#9e9e9e'">{{icon}}</mat-icon>
  <span *ngIf="showCheckBox" (click)="onSelectedChange($event)">
    <mat-checkbox [id]="checkboxId" [aria-labelledby]="checkboxLabel" [checked]="selected" [disabled]="readonly" style="margin-right: 1rem;" />
  </span>
  <span [id]="checkboxLabel">{{title}}</span>
</div>
<div>
  <a *ngIf="showDrilldown" class="secondary-content grey-text" (click)="onDrilldown($event)"
    tabindex="0" (keydown.enter)="onDrilldown($event)" (keydown.space)="$event.preventDefault(); onDrilldown($event)">
    <mat-icon id="rightChevron" class="align-middle">chevron_right</mat-icon>
  </a>
  <a *ngIf="editingTemplate || (!templateReadonly && showDeleteButton)" class="secondary-content as-danger-text" (click)="removeSelection()"
    tabindex="0" (keydown.enter)="removeSelection()" (keydown.space)="$event.preventDefault(); removeSelection()">
    <mat-icon id="clearSelection" class="align-middle">clear</mat-icon>
  </a>
</div>
